import * as React from 'react';
import type { BarrioDelivery as BarrioDeliveryType, BarrioInfo } from '../../types/barrios-landing';

interface BarrioDeliveryProps {
  barrio: BarrioInfo;
  delivery: BarrioDeliveryType | null;
  whatsappUrl: string;
}

export function BarrioDelivery({ barrio, delivery, whatsappUrl }: BarrioDeliveryProps) {
  return (
    <section className="bs-delivery">
      <style>{`
        .bs-delivery {
          padding: 64px 24px;
          background: #fff;
        }
        .bs-delivery-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .bs-delivery h2 {
          font-size: 26px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .bs-delivery .section-sub {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 28px;
        }
        .bs-turns {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }
        .bs-turn-card {
          display: flex;
          align-items: center;
          gap: 14px;
          background: #f0fdf0;
          border-radius: 10px;
          padding: 16px 18px;
          border: 1px solid #d4edda;
        }
        .bs-turn-icon {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #1EAA25;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .bs-turn-icon i {
          color: #fff;
          font-size: 18px;
        }
        .bs-turn-day {
          font-size: 16px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 2px;
        }
        .bs-turn-shift {
          font-size: 14px;
          color: #666;
          margin: 0;
        }
        .bs-no-delivery {
          text-align: center;
          padding: 32px 24px;
          background: #fafaf7;
          border-radius: 12px;
          border: 1px solid #eee;
        }
        .bs-no-delivery p {
          font-size: 16px;
          color: #666;
          margin: 0 0 16px;
        }
        .bs-no-delivery a {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          background: #25D366;
          color: #fff;
          font-size: 15px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .bs-no-delivery a:hover {
          background: #1da851;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .bs-turns {
            grid-template-columns: 1fr;
          }
          .bs-delivery h2 {
            font-size: 22px;
          }
        }
      `}</style>
      <div className="bs-delivery-inner">
        <h2>Entregas en {barrio.name}</h2>
        <p className="section-sub">Próximos turnos de entrega disponibles</p>

        {delivery && delivery.turns.length > 0 ? (
          <div className="bs-turns">
            {delivery.turns.map((turn, i) => (
              <div key={i} className="bs-turn-card">
                <div className="bs-turn-icon">
                  <i className="fa fa-truck" />
                </div>
                <div>
                  <p className="bs-turn-day">{turn.day_name}</p>
                  <p className="bs-turn-shift">{turn.shift}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bs-no-delivery">
            <p>Consultanos por delivery a {barrio.name}</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp" /> Escribinos por WhatsApp
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
